import React from "react";
import "./AboutGameScore.scss";
import campaignWeathervaneLogo from "../../assets/img/campaign-weathervane-logo.webp";
import ScoreMeter from "../ScoreMeter/ScoreMeter";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Typography } from "@mui/joy";

function AboutGameScore(props) {
	return (
		<div className="about-container">
			<div className="img-container">
				<img
					className="campaign-weathervane-logo"
					src={campaignWeathervaneLogo}
					alt={"Campaign Weathervane logo"}
				/>
			</div>
			<h2>About the Game Score Meter</h2>
			<Grid container sx={{ alignItems: "center", justifyContent: "center", marginTop: 3 }}>
				<Grid sx={{ marginRight: 3 }} item>
					<FaArrowLeft size={20} color="#FF0000" />
				</Grid>
				<Grid item>
					<Box sx={{ textColor: "#000000", fontWeight: "700"}}>
						Favorability
					</Box>
				</Grid>
				<Grid sx={{ marginLeft: 3 }} item>
					<FaArrowRight size={20} color="#008000" />
				</Grid>
			</Grid>
			<Box sx={{ width: "100%", marginTop: 1 }}>
				<ScoreMeter percentage={50} />
			</Box>
			<Box
				sx={{
					textAlign: "center",
					fontWeight: "600",
					color: "#000000",
				}}>
				50%
			</Box>
			<Box
				sx={{
					paddingX: 5,
					marginTop: 4,
					color: "#000000",
					lineHeight: 1.5,
				}}>
				<p>
					The game score meter begins at 50% "favorability". As a presidential candidate, you want to
					understand the views of the American people to win their favor and ultimately, win the election.
				</p>
				<p>
					Depending on your responses to the questions, your "favorability" to the general public will go up
					or down. The higher your "favorability" is, the more likely you are to win the election!
				</p>
				<p>
					Demarcations on the game score meter align with the election's outcome. There are four possible
					outcomes of the Campaign Weathervane:
				</p>
				<div>
					<ol>
						<li>
							{"Score < 51: Candidate Weathervane lost the race, but still had a great showing for a" +
								" third party candidate. History remains the same."}
						</li>
						<li>
							{"Score <= 60: Candidate weathervane won the race by a slim margin and changed history!"}
						</li>
						<li>{"Score <= 80: Candidate weathervane won the race decisively and changed history!"}</li>
						<li>Score {">"} 80: Candidate weathervane successfully changed history by a landslide!</li>
					</ol>
				</div>
				<p>
					So, what are you waiting for? Go change history, Candidate Weathervane!
				</p>
			</Box>
		</div>
	);
}

export default AboutGameScore;
